import { MicrositeFile } from "@getregistered/greg-editors/dist/lib/domain/microsite/types";
import railsFetch from "../../components/railsFetch";

type FileUploadHandler = (file: File) => Promise<MicrositeFile>;

// GR-1893: Server-side allowlist on FileUpload means /admin/file_uploads now
// returns 422 with { "file": ["..."] } when an upload is rejected (wrong type,
// too large). Without checking response.ok the error JSON was being treated
// as a MicrositeFile and dispatched into the Y.Doc, silently corrupting the
// section. Match the TipTap pattern: alert the user and throw so greg-editors
// skips the section update.
const extractUploadErrorMessage = async (response: Response): Promise<string> => {
  try {
    const body = await response.json();
    const messages = Array.from(
      new Set(
        Object.values(body)
          .flat()
          .filter((m): m is string => typeof m === "string"),
      ),
    );
    if (messages.length > 0) return messages.join(". ");
  } catch {
    // fall through
  }
  return `HTTP ${response.status}`;
};

export const processFileUpload = async (
  fileUploadUrl: string,
  file: File
): Promise<MicrositeFile> => {
  const formData = new FormData();
  formData.append("file_upload[file]", file, file.name);
  const response = await railsFetch(fileUploadUrl, {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    const message = await extractUploadErrorMessage(response);
    window.alert(`Upload failed: ${message}`);
    throw new Error(`Upload failed (${response.status}): ${message}`);
  }

  return await response.json();
};

export const createFileUploadHandler = (
  fileUploadUrl: string
): FileUploadHandler => {
  return async (file: File): Promise<MicrositeFile> => {
    return await processFileUpload(fileUploadUrl, file);
  };
};
